import { useMemo } from 'react'

const useQueryParams = <T = any>() => {
  const search = window.location.search
  const searchParams = useMemo(() => new URLSearchParams(search), [search])
  const params = Object.fromEntries(searchParams.entries())
  return params as T
}

export default useQueryParams
